"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaElement = exports.DEFAULT_ELEMENT_BOUNDS = void 0;
const Elements_1 = require("../helpers/Elements");
const superTemplate = (html, styles) => `
<style>${styles}</style>
${html}
`;
exports.DEFAULT_ELEMENT_BOUNDS = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
};
class MetaElement extends HTMLElement {
    constructor(options) {
        super();
        this._template = '';
        this._styles = '';
        const { template, styles } = options;
        this.attachShadow({ mode: 'open' });
        this._template = template;
        this._styles = styles;
        this._updateShadowRoot();
    }
    set styles(value) {
        this._styles = value;
        this._updateShadowRoot();
    }
    set template(value) {
        this._template = value;
        this._updateShadowRoot();
    }
    cleanShadowRoot() {
        var _a, _b, _c;
        while ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.firstElementChild) {
            (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.removeChild((_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.firstElementChild);
        }
    }
    _updateShadowRoot() {
        var _a;
        this.cleanShadowRoot();
        const nodes = document.createElement('template');
        nodes.innerHTML = superTemplate(this._template, this._styles);
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.append(nodes.content.cloneNode(true));
    }
    get firstMeaningfulChild() {
        var _a, _b;
        return (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(':not(style)')) !== null && _b !== void 0 ? _b : null;
    }
    calculateBounds() {
        var _a, _b;
        const parentRect = (_b = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : { x: 0, y: 0 };
        const rect = (0, Elements_1.getBoundingBoxForElementAndChildren)(this);
        rect.x -= parentRect.x;
        rect.y -= parentRect.y;
        const result = Object.assign(Object.assign({}, rect), { fontSize: 0, fontStyle: '', paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, textAlign: 'center', textColor: 'black', lineSpacing: 0, fullElementBounds: Object.assign({}, rect) });
        const computedStyle = getComputedStyle(this);
        result.fontSize = parseFloat(computedStyle.fontSize);
        result.fontStyle = computedStyle.fontWeight;
        result.textAlign = computedStyle.textAlign;
        result.textColor = computedStyle.color;
        result.lineSpacing = parseFloat(computedStyle.lineHeight);
        return result;
    }
}
exports.MetaElement = MetaElement;
